import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axiosInstance from "../axios/axios";
import ErrorMessage from "./ErrorMessage";
// import VerificationModal from "./VerificationModal"; // Make sure this component exists and path is correct

const CreateCompanyAccount = () => {
  const [companyName, setCompanyName] = useState("");
  const [companyNumber, setCompanyNumber] = useState("");
  const [companyAddress, setCompanyAddress] = useState("");
  const [companyState, setCompanyState] = useState("");
  const [companyCac, setCompanyCac] = useState("");
  const [companyLink, setCompanyLink] = useState("");
  const [locations, setLocations] = useState([]);
  const [error, setError] = useState("");
  // const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const response = await axiosInstance.get("locations");
        setLocations(response.data.data.map((state) => state.name));
      } catch {
        console.log("Error fetching locations");
      }
    };
    fetchLocations();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const userDetails = JSON.parse(localStorage.getItem("formDetails")) || {};

    const formData = {
      email: userDetails.email,
      password: userDetails.password,
      company_name: companyName,
      phone: companyNumber,
      role: userDetails.userRole,
      company_street_address: companyAddress,
      company_state: companyState,
      company_cac_number: companyCac,
      interview_link: companyLink,
    };

    axiosInstance
      .post("auth/register", formData)
      .then((response) => {
        const res = response.data.details;
        localStorage.setItem("user_id", res.user_id);
        localStorage.setItem("role_specific_id", res.id);

        const data = response.data;
        console.log(data);
        if (data.role === "organization") {
          navigate("/unverified-company");
        } else {
          navigate("/dashboard/jobs");
        }
      })
      .catch((err) => {
        console.error("Registration error:", err);
        setError(err.response?.data?.message || "Registration failed.");
      });
  };

  return (
    <form
      className="flex flex-col w-full items-center justify-center py-[48px]"
      onSubmit={handleSubmit}
    >
      <section className="flex flex-col gap-2 w-3/4 max-w-[640px]">
        <div className="w-full font-bold text-xl mb-[44px] font-[Be Vietnam Pro]">
          Create a Company Account
        </div>
        <section className="flex flex-col gap-[24px]">
          <div className="flex flex-col w-full">
            <label className="form-label">Your Company&apos;s Name</label>
            <input
              required
              type="text"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              className="custom-form"
              placeholder="Enter company Name"
            />
          </div>

          <div className="flex flex-col w-full">
            <label className="form-label">
              Your Company&apos;s Mobile Number
            </label>
            <input
              required
              type="number"
              value={companyNumber}
              onChange={(e) => setCompanyNumber(e.target.value)}
              className="custom-form"
              placeholder="Enter your Company number"
            />
          </div>

          <div className="flex flex-col w-full">
            <label className="form-label">Your Company&apos;s Address</label>
            <input
              required
              type="text"
              value={companyAddress}
              onChange={(e) => setCompanyAddress(e.target.value)}
              className="custom-form"
              placeholder="Enter your Address"
            />
          </div>

          <div className="flex flex-col w-full">
            <label className="form-label">Your Company&apos;s State</label>
            <select
              required
              className="custom-form"
              value={companyState}
              onChange={(e) => setCompanyState(e.target.value)}
            >
              <option value="">-- Select your State --</option>
              {locations.map((location, index) => (
                <option key={index} value={location}>
                  {location}
                </option>
              ))}
            </select>
          </div>

          <div className="flex flex-col w-full">
            <label className="form-label">Your Company&apos;s CAC</label>
            <input
              required
              type="number"
              value={companyCac}
              onChange={(e) => setCompanyCac(e.target.value)}
              className="custom-form"
              placeholder="Enter your Company CAC"
            />
          </div>

          <div className="flex flex-col w-full">
            <label className="form-label">Your Interview Link</label>
            <input
              type="text"
              value={companyLink}
              onChange={(e) => setCompanyLink(e.target.value)}
              className="custom-form"
              placeholder="Enter your Interview Link"
            />
          </div>
        </section>

        {/* {showModal && (
          <VerificationModal
            showModal={showModal}
            setShowModal={setShowModal}
          />
        )} */}
        {error && <ErrorMessage message={error} />}

        <Link to="/login" className="custom-forgot">
          Login
        </Link>
        <button
          type="submit"
          className="btn bg-[#049645] hover:bg-[#1E4929] text-white w-full font-bold text-lg my-[24px]"
        >
          Finish
        </button>
      </section>
    </form>
  );
};

export default CreateCompanyAccount;
